import { styled } from '@uhg-abyss/web/tools/styled';

export const emphasisBannerStyle = (mobileScreen: boolean) => ({
  'abyss-emphasis-banner-root': {
    position: 'relative',
    width: '100%',
    boxSizing: 'border-box',
    borderWidth: '1px',
    borderStyle: 'solid',
    borderColor: '#C3D8F2',
    borderRadius: '8px',
    backgroundColor: '#EEF8FB',
    marginTop: '24px',
    marginRight: mobileScreen ? '8px' : '0px',
    marginLeft: mobileScreen ? '8px' : '0px',
    paddingTop: '16px',
    paddingRight: '16px',
    paddingBottom: '16px',
    paddingLeft: '16px',
    alignItems: 'flex-start',
    '& .abyss-emphasis-banner-wrapper': {
      width: '100%',
      maxWidth: '100%',
      alignItems: 'flex-start',
      gap: '8px',
    },
    '& .abyss-emphasis-banner-icon-brand': {
      flexShrink: 0,
      marginTop: '0px',
      width: '50px',
      height: '50px',
    },
    '& .abyss-emphasis-banner-main-content': {
      gap: 0,
      width: '100%',
      paddingRight: mobileScreen ? '28px' : '32px',
    },
    '& .abyss-emphasis-banner-content': {
      width: '100%',
      gap: '0px',
    },
    // '& .abyss-emphasis-banner-text-container': {
    //   display: 'none',
    // },
    '& .abyss-emphasis-banner-title-container': {
      width: '100%',
    },
    '& .abyss-emphasis-banner-title': {
      fontSize: '18px',
      lineHeight: '22px',
      fontWeight: 700,
      color: '#323334',
      margin: 0,
    },
    '& .abyss-emphasis-banner-body-text': {
      display: 'block',
      width: 'auto',
      flex: '0 1 auto',
      flexShrink: 1,
      fontSize: '14px',
      lineHeight: '18px',
      fontWeight: 500,
      color: '#323334',
      whiteSpace: 'normal',
    },
    '& .abyss-emphasis-banner-separator': {
      display: 'none',
    },
    '& .abyss-emphasis-banner-close-button': {
      position: 'absolute !important',
      top: '16px !important',
      right: '16px !important',
      minHeight: '20px !important',
      minWidth: '20px !important',
      height: '20px !important',
      width: '20px !important',
      padding: '0 !important',
      display: 'flex !important',
      alignItems: 'center !important',
      justifyContent: 'center !important',
      alignSelf: 'flex-start',
      zIndex: 10,
      visibility: 'visible !important',
      // opacity: '1 !important',
    },
    '& .abyss-emphasis-banner-close-icon': {
      width: '20px !important',
      height: '20px !important',
      fontSize: '20px !important',
      display: 'flex !important',
      visibility: 'visible !important',
      opacity: '1 !important',
    },
  },
});

export const virtualCareBannerContentStyle = {
  width: '100%',
  gap: '8px',
};

export const virtualCareBannerHeaderStyle = (
  mobileScreen: boolean,
  expandedProviderListView: boolean
) => {
  const shouldInlineMessage =
    (mobileScreen && !expandedProviderListView) || expandedProviderListView;

  return {
    width: shouldInlineMessage ? 'auto' : '100%',
    display: 'flex',
    alignItems: shouldInlineMessage ? 'center' : 'flex-start',
    flexDirection: shouldInlineMessage ? 'row' : 'column',
    columnGap: shouldInlineMessage ? '16px' : '0px',
    rowGap: '8px',
  };
};

export const virtualCareBannerLinkStyle = {
  'abyss-link-root': {
    fontSize: '16px',
    lineHeight: '20px',
    display: 'inline-flex',
    alignItems: 'center',
    width: 'fit-content',
  },
};

export const slideStyleSnack = {
  'abyss-slide-container': {
    backgroundColor: 'white',
    boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.12)',
    border: ' 1px solid #E5E5E6',

    visibility: 'visible',
    borderRadius: '8px',
    height: 'auto',
  },
};

export const carouselStyle = (mobileScreen: boolean) => ({
  'abyss-carousel-swiper-container': {
    display: 'flex',
    willChange: 'transform',
    width: 'auto',
    paddingLeft: '3px',
  },
  'abyss-carousel-slide-container': {
    position: 'relative',
    gap: '12px',
    width: mobileScreen ? '155px' : '1054px',
  },
  'abyss-carousel-minimal-controls': {
    marginTop: '8px',
    padding: '0px',
    height: '20px',
    'button.abyss-carousel-minimal-pagination-container': {
      padding: ' 0 4px 0 4px',
      display: 'block',
      width: 'auto',
    },
  },
  'abyss-carousel-minimal-nav-icon-right': {
    width: '20px',
    height: '20px',
  },
  'abyss-carousel-minimal-nav-container-right': {
    width: '20px',
    height: '20px',
    padding: '0px',
    top: '-3px',
  },
  'abyss-carousel-minimal-nav-container-left': {
    width: '20px',
    height: '20px',
    padding: '0px',
    top: '-3px',
  },

  'abyss-carousel-minimal-nav-icon-left': {
    width: '20px',
    height: '20px',
  },
  'abyss-carousel-minimal-pagination-container': {
    padding: '0 8px 0 8px',
  },
});

export const slideStyle = {
  'abyss-slide-container': {
    marginLeft: '0',
    paddingLeft: '0',
    backgroundColor: '$EEF8FB',
  },
};

export const primarySlideStyle = {
  'abyss-slide-container': {
    marginLeft: '0',
    paddingLeft: '0',
    backgroundColor: '$EEF8FB',
    width: '100%',
    flex: '0 0 100%',
  },
  'abyss-slide-card': {
    padding: 0,
    border: 'none',
    height: '100%',
  },
};

export const slideContainerStyle = {
  'abyss-slide-content-wrapper': {
    padding: '0',
    visibility: 'visible',
  },
};

export const allVirtualCareSlideStyle = {
  'abyss-slide-container': {
    width: '210px',
  },
};

export const viewAllCardCss = (mobileScreen: boolean) => ({
  border: '1px solid #C3D8F2',
  borderRadius: '8px',
  background: '#fff',
  padding: '16px',
  width: mobileScreen ? '155px' : '160px',
  display: 'flex',
  flexDirection: 'column',
  boxShadow: '0 2px 8px rgba(0,0,0,0.04)',
  justifyContent: 'center',
  alignItems: 'center',
  boxSizing: 'border-box',
});
export const viewAllCardCssOnMedical = (mobileScreen: boolean) => ({
  border: '1px solid #E5E5E6',
  borderRadius: '8px',
  background: '#fff',
  padding: '16px',
  width: mobileScreen ? '155px' : 'auto',
  display: 'flex',
  flexDirection: 'column',
  boxShadow: '0 2px 8px rgba(0,0,0,0.04)',
  justifyContent: 'center',
  alignItems: 'center',
  boxSizing: 'border-box',
});

export const viewAllLinkCss = {
  'abyss-link-root': {
    display: 'flex',
    width: '100%',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
};

export const virtualCareProviderCardCss = (
  mobileScreen: boolean,
  primaryCareVirtual: boolean
) => ({
  border: '1px solid #E5E5E6',
  borderRadius: '8px !important',
  background: '#fff',
  padding: '16px',
  width: primaryCareVirtual ? '100%' : mobileScreen ? '155px' : '270px',
  display: 'flex',
  flexDirection: 'column',
  boxShadow: '0 2px 8px rgba(0,0,0,0.04)',
  height: '100%',
  justifyContent: 'center',
});

export const virtualCareProviderCardText = (mobileScreen: boolean) => ({
  maxWidth: mobileScreen ? '120px' : '146px',
  lineHeight: '18px',
  marginTop: '8px',
  color: '#323333',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  fontSize: '14px',
});

export const virtualCareProviderCardLinkCss = (mobileScreen: boolean) => ({
  'abyss-link-root': {
    fontSize: '14px',
    lineHeight: '18px',
    fontWeight: 600,
    textAlign: 'center',
    marginLeft: mobileScreen ? '0px' : '4px',
    marginTop: mobileScreen ? '8px' : '0px',
    fontFamily: '$primary',
  },
});
export const virtualCareSpecialityCardCss = (
  fromViewAll: boolean,
  mobileScreen: boolean,
  primaryCareVirtual: boolean
) => ({
  width: fromViewAll
    ? '120px'
    : primaryCareVirtual
    ? '100%'
    : mobileScreen
    ? '140px'
    : '130px',
  height: primaryCareVirtual && 'auto',
});

export const LogoNotAvailableContainer = styled('div', {
  width: '85px',
  height: '35px',
  background: '#F3F3F3',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  borderRadius: 4,
  '@media (max-width: 600px)': {
    width: '50px',
    height: 'auto',
  },
});
